import axios from "axios"
import * as urlWebservice from "utils/apis"

function defaultOptions() {
  const token = localStorage.getItem("resuxi-token")
  const globalSettings = {
    headers: {
      "x-access-token": token,
    },
  }
  return globalSettings
}
export function defaultOptionsMultipart() {
  const token = localStorage.getItem("resuxi-token")
  const globalSettings = {
    headers: {
      "Content-Type": "multipart/form-data",
      "x-access-token": token,
    },
  }
  return globalSettings
}

export function defaultManagementOptions() {
  const globalSettings = {
    headers: {
      "x-api-key": urlWebservice.API_KEY,
    },
  }
  return globalSettings
}

// Get method
export const get = async (url, options = defaultOptions()) => {
  try {
    const { data } = await axios.get(url, options)
    return data
  } catch (error) {
    throw new Error(error)
  }
}

// Post method
export const post = async (url, payload, options = defaultOptions()) => {
  try {
    const { data } = await axios.post(url, payload, options)
    return data
  } catch (error) {
    throw new Error(error)
  }
}

export const postAUth = async (url, payload, options = defaultOptions()) => {
  try {
    const data = await axios.post(url, payload, options)
    return data
  } catch (error) {
    throw new Error(error)
  }
}

// Update method
export const update = async (url, payload, options = defaultOptions()) => {
  try {
    const data = await axios.patch(url, payload, options)
    return data
  } catch (error) {
    throw new Error(error)
  }
}
export const putMethod = async (url, payload, options = defaultOptions()) => {
  try {
    const data = await axios.put(url, payload, options)
    return data
  } catch (error) {
    return error
  }
}

// Remove method
export const remove = async (url, options = defaultOptions()) => {
  try {
    const { data } = await axios.delete(url, options)
    return data
  } catch (error) {
    throw new Error(error)
  }
}


// Safer Post method (preserves error.response)
export const postSafe = async (url, payload, options = defaultOptions()) => {
  try {
    const response = await axios.post(url, payload, options)
    return response
  } catch (error) {
    if (error.response) {
      return error.response
    } else {
      throw error
    }
  }
}

// Safer Update method (preserves error.response)
export const updateSafe = async (url, payload, options = defaultOptions()) => {
  try {
    const data = await axios.patch(url, payload, options)
    return data
  } catch (error) {
    if (error.response) {
      return error.response
    } else {
      throw error
    }
  }
}

// Safer remove method (preserves error.response)
export const removeSafe = async (url, options = defaultOptions()) => {
  try {
    const { data } = await axios.delete(url, options)
    return data
  } catch (error) {
    if (error.response) {
      return error.response
    } else {
      throw error
    }
  }
}
